import {UI} from "../../../../../stem-core/src/ui/UIBase.js";
import {UserDashboardSection} from "../components/UserDashboardSection.jsx";
import {UserDashboardTab, UserDashboardTabStyle} from "./UserDashboardTab.jsx";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService.js";
import {Messages} from "../../../../Messages.js";
import {userService} from "../../../../../client/connection/services/UserService.js";
import {CheckboxInput} from "../../../../../stem-core/src/ui/input/checkbox/CheckboxInput.jsx";
import {
    apiUserUpdateNewsletterSubscriptions,
    MerchantAudienceMemberStore,
    NewsletterSubscriptionUpdateType
} from "../../../../../client/state/merchant/MerchantAudienceMemberStore.js";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme.js";
import {styleRule} from "../../../../../stem-core/src/decorators/Style.js";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {MessageElement} from "../../../../widget/ui/MessageElement.jsx";
import {MerchantUserStore} from "../../../../../client/state/merchant/MerchantUserStore.js";
import {MerchantAudienceStore} from "../../../../../client/state/merchant/MerchantAudienceStore.js";
import {Toast} from "../../../../ui/Toast.jsx";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw.js";
import {Flow} from "../../../flows/Flow.js";


class UserDashboardNewslettersTabStyle extends UserDashboardTabStyle {
    @styleRule
    checkboxesList = {
        padding: "16px 0",
    };

    @styleRule
    separatorLine = {
        width: "100%",
        height: 0.5,
        background: "#E5E5E5",
    };

    @styleRule
    message = {
        marginTop: 16,
    };
}

@autoredraw(MerchantAudienceMemberStore)
@registerStyle(UserDashboardNewslettersTabStyle)
export class UserDashboardNewslettersTab extends UserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.newslettersTitle,
        }
    }

    @wrapInSpinner
    async update(newsletterIds = [], updateType = NewsletterSubscriptionUpdateType.SUBSCRIBE) {
        const emailAddress = userService.getUserEmail();
        const {merchantId} = iFrameMerchantService;
        const merchantUser = MerchantUserStore.getByUserAndMerchant(userService.getUserId(), merchantId);

        const request = {
            emailAddress, // TODO this should be the userId if we're authenticated
            merchantId,
            newsletterIds,
            updateType,
        };

        const canReceivePromotionalEmails = this.promotionalEmailsCheckbox.getValue();

        if (canReceivePromotionalEmails !== merchantUser.canReceivePromotionalEmails) {
            request.canReceivePromotionalEmails = canReceivePromotionalEmails;
        }

        await apiUserUpdateNewsletterSubscriptions(request);

        Toast.showSuccess(Messages.changesSaved);
    }

    render() {
        const {styleSheet} = this;
        const newsletters = Flow.newsletter.getNewsletters();
        const merchantName = iFrameMerchantService.getMerchant().name;
        const merchantUser = MerchantUserStore.getByUserAndMerchant(userService.getUserId(), iFrameMerchantService.merchantId);

        const individualNewsletterCheckboxes = newsletters.map(audience => <CheckboxInput
            label={audience.name}
            onChange={enabled => this.update([audience.id], enabled ? NewsletterSubscriptionUpdateType.SUBSCRIBE : NewsletterSubscriptionUpdateType.UNSUBSCRIBE)}
            initialValue={MerchantAudienceMemberStore.find(member => member.isSubscribed() && member.audience === audience) != null}
            className={styleSheet.textSection}
        />);

        return <UserDashboardSection titleMessage={<MessageElement message={Messages.signUpForMerchantNewsletter} args={[merchantName]}/>}>
            <MessageElement
                message={Messages.newslettersEditDescription(userService.getUserEmail())}
            />
            <div className={styleSheet.checkboxesList}>
                {individualNewsletterCheckboxes}
                {individualNewsletterCheckboxes.length > 0 && <div className={styleSheet.separatorLine}/>}
                <CheckboxInput
                    ref="promotionalEmailsCheckbox"
                    label={Messages.allowPromotionalEmailsFromMerchant(merchantName)}
                    className={styleSheet.textSection}
                    onChange={() => this.update()}
                    initialValue={!merchantUser || merchantUser.canReceivePromotionalEmails}
                />
            </div>
            <MessageElement
                message={Messages.newsletterDashboardEmailDescription(userService.getUserEmail())}
                className={styleSheet.message}
            />
        </UserDashboardSection>
    }
}
